import { LicenseLock } from './LicenseHint';
import { useUnlicensedModule } from './useUnlicensedModule';

/** Schloss für Kopfleisten ohne Seitentitel (Reiter): nur, wenn das Modul der aktuellen Seite nicht gebucht ist. */
export const ModuleLicenseLock = () => {
  const hint = useUnlicensedModule();
  return hint ? <LicenseLock hint={hint} /> : null;
};
